import { useState, useEffect } from 'react';
import Keycloak from 'keycloak-js';
import { KeycloakUserInfo } from '../types';

interface UseKeycloakReturn {
  keycloak: Keycloak | null;
  authenticated: boolean;
  loading: boolean;
  userInfo: KeycloakUserInfo | null;
  logout: () => void;
}

export const useKeycloak = (): UseKeycloakReturn => {
  const [keycloak] = useState<Keycloak>(() => 
    new Keycloak({
      url: 'https://oauth.dotnethub.pl',
      realm: 'DotnetHub',
      clientId: 'dotnethub-web'
    })
  );
  
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [userInfo, setUserInfo] = useState<KeycloakUserInfo | null>(null);

  useEffect(() => {
    keycloak.init({ 
      onLoad: 'login-required',
      checkLoginIframe: false,
      redirectUri: window.location.origin // Will redirect back to dotnethub.pl
    }).then((auth) => {
      setAuthenticated(auth);
      setLoading(false);
      
      if (auth) {
        keycloak.loadUserInfo().then((info) => {
          setUserInfo(info as KeycloakUserInfo);
        });
      }
    }).catch((error) => {
      console.error('Keycloak initialization failed:', error);
      setLoading(false);
    });

    // Token refresh
    const refreshInterval = setInterval(() => {
      keycloak.updateToken(70).catch(() => {
        console.error('Failed to refresh token');
        keycloak.logout();
      });
    }, 60000);

    return () => {
      clearInterval(refreshInterval);
    };
  }, [keycloak]);

  const logout = () => {
    keycloak.logout({
      redirectUri: window.location.origin
    });
  };

  return {
    keycloak,
    authenticated,
    loading,
    userInfo,
    logout
  };
};
